// extracted by mini-css-extract-plugin
export default {"container":"reject-modal_container__N55LC","actions":"reject-modal_actions__B+Pa2","observation":"reject-modal_observation__Km2IM","warning":"reject-modal_warning__Egyw9"};